import { Box, Typography } from '@mui/material';

interface BlockListErrorProps {
  message?: string;
}

export const BlockListError = ({ message }: BlockListErrorProps) => (
  <Box p={2}>
    <Typography variant="h6" color="error" mt={5} mb={3}>
      Please contact support
    </Typography>
    <Typography variant="h6" color="error" fontWeight={100}>
      Error: {message || 'An unknown error occurred'}
    </Typography>
  </Box>
);
